import React from 'react';
import Select from 'react-select';

const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim();

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        padding: '7px 10px',
        minHeight: 'auto',
        boxShadow: 'none',
        borderColor: state.isFocused ? primaryColor : '#ccc',
        '&:hover': {
            borderColor: primaryColor,
        },
        lineHeight: '1.5',
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: 0,
    }),
    input: (provided) => ({
        ...provided,
        margin: 0,
        padding: 0,
        color: '#000',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        padding: 0,
    }),
    indicatorSeparator: () => null, // removes the "|" line
    menu: (provided) => ({
        ...provided,
        maxHeight: '300px',
        overflowY: 'auto',
        zIndex: 9999,
    }),
    menuList: (provided) => ({
        ...provided,
        maxHeight: '300px',
        overflowY: 'auto',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? primaryColor
            : state.isFocused
                ? '#f0f8ff'
                : '#fff',
        color: state.isSelected ? '#fff' : '#000',
        padding: '8px 10px',
        cursor: 'pointer',
    }),
};

const MultiSelect = ({ options, value, onChange, placeholder }) => {
    return (
        <Select
            options={options}
            value={value}
            onChange={onChange}
            styles={customStyles}
            placeholder="Select values..."
            isMulti
            components={{ IndicatorSeparator: () => null }}
        />
    );
};

export default MultiSelect;
